import { render } from "./ShowEmailModal.vue?vue&type=template&id=33edb61c&scoped=true"
import script from "./ShowEmailModal.vue?vue&type=script&lang=js"
export * from "./ShowEmailModal.vue?vue&type=script&lang=js"

import "./ShowEmailModal.vue?vue&type=style&index=0&id=33edb61c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33edb61c"]])

export default __exports__